import type { ReactNode } from 'react';
import { T } from '../../theme/tokens';

interface Props {
  title: string;
  /* A second line under the title, for screens that need to say what they are. */
  subtitle?: string;
  /* Filters, month pickers, tab strips: anything that acts on the whole page lives
     on the far side of the title bar instead of floating above the content. */
  children?: ReactNode;
}

export default function Header({ title, subtitle, children }: Props) {
  return (
    // RTL: every title in this app is Hebrew, and a Hebrew heading belongs on the
    // right — the side the eye starts from.
    <header
      dir="rtl"
      style={{
        background: T.card,
        borderBottom: `1px solid ${T.border}`,
        padding: '14px 24px',
        display: 'flex', alignItems: 'center', gap: 20, flexWrap: 'wrap',
        flexShrink: 0,
      }}
    >
      <h1 style={{
        fontSize: 23, fontWeight: 800, color: T.ink,
        letterSpacing: '-.025em', lineHeight: 1.15, margin: 0, minWidth: 0,
      }}>
        {title}
      </h1>

      {subtitle && (
        <div style={{ fontSize: 12.5, color: T.inkSoft, alignSelf: 'center' }}>
          {subtitle}
        </div>
      )}

      {/* `marginInlineStart: auto` pushes the controls to the far (left) end in RTL,
          so the title and the filters sit at opposite ends of one line. */}
      {children && (
        <div style={{
          marginInlineStart: 'auto', display: 'flex', alignItems: 'center',
          gap: 10, flexWrap: 'wrap',
        }}>
          {children}
        </div>
      )}
    </header>
  );
}
